import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "types/redux";

export const createClusterSelector = (id: string | undefined) => (state: RootState) =>
  id === undefined ? undefined : state.domains.clusters.data[id];

export const createClustersSelector = (ids: string[]) =>
  createSelector(...ids.map(createClusterSelector), (...clusters) => clusters.filter((item) => item !== undefined));

export const createDigDeeperSelector = (id: string | undefined) => (state: RootState) =>
  id === undefined ? undefined : state.domains.clusters.data[id]?.digDeeperKnowledge;
